import { render, staticRenderFns } from "./new-rule-group.component.vue?vue&type=template&id=9a79eae0&scoped=true&"
import script from "./new-rule-group.component.vue?vue&type=script&lang=ts&"
export * from "./new-rule-group.component.vue?vue&type=script&lang=ts&"
import style0 from "./new-rule-group.component.vue?vue&type=style&index=0&id=9a79eae0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a79eae0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VForm,VIcon,VSpacer})
